import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
interface AuthorizerProps {
  resource: string;
  action: string;
  children: ReactNode;
}

export interface NewAuthRolePermissions {
    [key: string]: string[];
}

export const useAuthorizer = (resource: string, action: string) => {
  let permissions: NewAuthRolePermissions = useSelector((state: any) => state.userManager?.newAuthRolePermissions) ?? {};
  const hasPermission =  (resource in permissions) && (permissions[resource]?.includes(action));

  return {
    hasPermission
  }
}
const Authorizer = ({ resource, action, children }: AuthorizerProps) => {
let permissions: NewAuthRolePermissions = useSelector((state: any) => state.userManager?.newAuthRolePermissions) ?? {};

   if (Object.keys(permissions).length === 0) {
    return  <>{children}</>;
   }

  const hasPermission = 
    (resource in permissions) && (permissions[resource]?.includes(action));

  if (!hasPermission) return null;

  return <>{children}</>;
};

export default Authorizer;